/**
 * The dock's cards. `DrawOfferCard` is the only one with a store read, so it is
 * the only one with a model — and it calls it inside its own memoised leaf
 * (unit convention §1).
 */
import React from 'react';

import DrawOfferCardView from './DrawOfferCard.View';
import {useDrawOfferCardModel} from './DrawOfferCard.model';

export const DrawOfferCard = React.memo(function DrawOfferCard({
  opponentName,
}: {
  opponentName: string;
}) {
  return (
    <DrawOfferCardView
      opponentName={opponentName}
      {...useDrawOfferCardModel()}
    />
  );
});

export {default as NoticeLine} from './NoticeLine.View';
export {default as ThinkingCard} from './ThinkingCard.View';
